import React from 'react';
import { TooltipProps } from 'recharts';
import styled from 'styled-components';
import { ETFChartData } from '../pages/ETFDetails/types';
import { TriangleDownIcon, TriangleUpIcon } from '@radix-ui/react-icons';
import { COLOR_CODES } from '@/src/common/enum';

const TooltipContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 10px 32px;
  align-items: center;
  justify-content: center;
  background: #eaeaea;
  border: 1px solid #fffaf740;
  border-radius: 8px;
  font-family: 'Roboto Condensed', sans-serif;
  font-size: 15.28px;
  font-weight: 400;
  line-height: 17.91px;
  color: #000000;
  div {
    display: flex;
    align-items: center;
    column-gap: 4px;
  }
`;

const Percentage = styled.span<{ ispositive: boolean }>`
  text-align: left;
  font-weight: 500;
  color: ${(props) => (props.ispositive ? COLOR_CODES.GREEN : COLOR_CODES.RED)};
`;

const FormattedDate = styled.p`
  text-align: right;
  padding-left: 0.2rem;
  margin-left: 0.2rem;
  padding-bottom: 0.25rem;
`;

const formatDate = (dateString: string): string => {
  const options: Intl.DateTimeFormatOptions = {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  };
  return new Date(dateString).toLocaleDateString('en-GB', options);
};

const CustomTooltip = ({ active, payload }: TooltipProps<string, string>) => {
  if (active && payload && payload.length) {
    const data: ETFChartData = payload[0].payload;
    const formattedDate = formatDate(data.TradeDate);

    return (
      <TooltipContainer className="custom-tooltip">
        <div>
          <span>₹{data?.Price}</span>|
          <Percentage ispositive={data?.PercentageChange > 0}>
            {data?.PercentageChange < 0 ? (
              <TriangleDownIcon color={COLOR_CODES.RED} fontSize={6} />
            ) : (
              <TriangleUpIcon color={COLOR_CODES.GREEN} fontSize={6} />
            )}
            {data?.PercentageChange}%
          </Percentage>
        </div>
        <FormattedDate>{formattedDate}</FormattedDate>
      </TooltipContainer>
    );
  }
  return null;
};

export default CustomTooltip;
